import { motion } from "framer-motion";
import { PencilRuler, Layers, Workflow, DraftingCompass, BadgeCheck, Handshake } from "lucide-react";
import SectionHead from "../SectionHead";

const ITEMS = [
    {
        icon: PencilRuler,
        title: "Customized Manufacturing",
        desc: "Components manufactured according to customer drawings and specifications.",
    },
    {
        icon: Layers,
        title: "FRP & Epoxy Expertise",
        desc: "Focused manufacturing experience in fiberglass and epoxy-based insulation products.",
    },
    {
        icon: Workflow,
        title: "Flexible Production",
        desc: "Suitable for prototype, development and regular production requirements.",
    },
    {
        icon: DraftingCompass,
        title: "Drawing-Based Manufacturing",
        desc: "Capability to work from customer drawings and samples.",
    },
    {
        icon: BadgeCheck,
        title: "Quality Focus",
        desc: "Dimensional and visual inspection throughout the manufacturing process.",
    },
    {
        icon: Handshake,
        title: "Long-Term Partnership",
        desc: "We aim to develop long-term relationships with OEMs, manufacturers and industrial customers.",
    },
];

export const WhyUs = () => (
    <section id="why-us" className="py-24 md:py-32 scroll-mt-20">
        <div className="shell">
            <SectionHead
                num="11"
                overline="Why Choose Us"
                title="Why choose Naagarjun Power Fiber"
            />

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
                {ITEMS.map((item, i) => (
                    <motion.div
                        key={item.title}
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.55, delay: (i % 3) * 0.09 }}
                        data-testid={`whyus-card-${i + 1}`}
                        className="group relative bg-[#0e0e11] hover:bg-panel transition-colors duration-300 p-6 md:p-8 min-h-[210px] flex flex-col"
                    >
                        <span className="font-mono text-[10px] text-zinc-600 absolute top-6 right-6 tracking-[0.2em]">
                            /{String(i + 1).padStart(2, "0")}
                        </span>
                        <item.icon
                            size={26}
                            strokeWidth={1.5}
                            className="text-safety mb-auto"
                        />
                        <h3 className="font-display uppercase font-semibold tracking-wide text-lg md:text-xl text-zinc-50 mt-8 mb-3 group-hover:text-safety transition-colors">
                            {item.title}
                        </h3>
                        <p className="text-sm text-zinc-400 leading-relaxed">{item.desc}</p>
                        <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-safety group-hover:w-full transition-all duration-500" />
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default WhyUs;